"use client";

import { useMemo } from "react";
import { BottomNav, type BottomNavItem } from "@/components/layout/navigation/bottom-nav";
import { ROUTES } from "@/constants/routes";
import { Home, ArrowLeftRight, Swords, Wallet, User } from "lucide-react";
import { usePathname } from "next/navigation";

export const Menu = () => {
  const pathname = usePathname();

  const items = useMemo<BottomNavItem[]>(() => {
    // Match the exact route OR any nested subroute (e.g. `/[id]` campaign pages keep
    // the parent tab highlighted). Root `/` only matches itself.
    const isActive = (href: string) => {
      if (!pathname) return false;
      if (href === ROUTES.HOME) return pathname === href;
      return pathname === href || pathname.startsWith(`${href}/`);
    };

    return [
      { label: "Home", icon: Home, href: ROUTES.HOME, isActive: isActive(ROUTES.HOME) },
      // Hold & Earn stays reachable from the home page's NavigateButtons grid.
      {
        label: "Cede Arena",
        icon: Swords,
        href: ROUTES.CEDE_ARENA,
        variant: "arena",
        isActive: isActive(ROUTES.CEDE_ARENA),
      },
      // Trade & Earn is the center highlighted CTA
      {
        label: "Trade & Earn",
        icon: ArrowLeftRight,
        href: ROUTES.CAMPAIGNS,
        isHighlighted: true,
        isActive: isActive(ROUTES.CAMPAIGNS),
      },
      { label: "Portfolio", icon: Wallet, href: ROUTES.PORTFOLIO, isActive: isActive(ROUTES.PORTFOLIO) },
      { label: "Profile", icon: User, href: ROUTES.PROFILE, isActive: isActive(ROUTES.PROFILE) },
    ];
  }, [pathname]);

  return <BottomNav items={items} />;
};
